import styled from 'styled-components';
import { colors } from 'constants/colors';
import { StyledSwitchOption } from 'components/Switcher/SwitcherStyles';
import { selectedClassName } from 'components/PaymentSwitcher/constants';
import { mobileQuery } from 'utils/breakpoints';

export const StyledSwitcherSide = styled.div<{ sub?: string }>`
  position: relative;
  font-size: 36px;
  font-weight: bold;

  &, &:after {
    transition: all 0.2s;
  }

  &:after {
    content: '${({ sub }) => sub || ''}';
    font-size: 28px;
    color: ${colors.orange};
    background-color: ${colors.white};
    line-height: 48px;
    position: absolute;
    top: 50%;
    left: calc(16px + 100%);
    transform: translateY(-50%);
    padding: 0 20px;

    border-radius: 32px;
  }
  
  @media screen and ${mobileQuery} {
    font-size: 28px;

    &:after {
      font-size: 22px;
      line-height: 32px;
      left: -19px;
      bottom: -45px;
      top: auto;
    }
  }
`;

export const StyledPaymentSwitcher = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  min-width: 1000px;
  user-select: none;

  @media (max-width: 999px) {
    min-width: auto;
  }

  ${StyledSwitchOption} {
    &.${selectedClassName} {
      color: ${colors.white};
    }
  }
`;
